//公共地址
// export const sevUrl = 'http://localhost:8080/backstage'
// export const sevUrl = 'http://192.162.130.96:9113/backstage'//测试环境
export const sevUrl = '/backstage'//测试环境
// export const sevUrl = '/backstage'//生产环境
// export const sevUrl = 'http://172.160.1.169:9113/backstage'//生产环境



// WEBPACK FOOTER //
// ./src/utils/utils.js